import config from "src/config";
import { getData } from 'src/utils/axios/serverHelper';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { CompanyDto } from 'src/dtos/company/companyDto';

const baseUrl = `${config.apiUrl}/company`;

//메인페이지 사업장정보 조회
export const getCompanyList = async (searchText?: string) => {
  const url = `${baseUrl}/list`

  return await getData<ResponseDto<CompanyDto[]>>(url, searchText ? {
    params: {
      searchText
    }
  } : undefined);
}